import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnDestroy } from '@angular/core';
import { UtilService } from '../services';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'browse-search',
    template: `
        <mat-form-field style="height: 75px;">
            <input matInput placeholder="Search for Topics" [(ngModel)]="term" (keydown.enter)="doSearch()"(blur)="doSearch()">
        </mat-form-field>
    `
})
export class BrowseSearchComponent implements OnDestroy {
    private cleanupTime = new Subject<void>();
    isSearchPane: boolean;
    term: string;

    constructor(route: ActivatedRoute, private router: Router, private utilService: UtilService) {
        route.queryParams.pipe(takeUntil(this.cleanupTime))
        .subscribe(params => this.term = utilService.hasUrlSeg('search') ? params.term : '');
    }

    doSearch = () => {
        if(this.term && this.term.trim().length){
            this.router.navigate(['browse', 'search'], { queryParams: { term: this.term } });
        } else if(this.utilService.hasUrlSeg('search')) {
            this.router.navigate(['browse']);
        }
    }

    ngOnDestroy(): void {
        this.cleanupTime.next();
        this.cleanupTime.complete();
    }
}
